import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Download } from "react-bootstrap-icons";
import { useCachedFile } from "@/shared/lib/use-cached-file";
import { downloadFile, FileItem } from "@/shared/lib";

interface TextFileProps {
  file: FileItem;
  isSelected?: boolean;
  onClick?: (url: string) => void;
}

export const TextFile: React.FC<TextFileProps> = ({ file, isSelected, onClick }) => {
  const [hovered, setHovered] = useState(false);

  const { cachedFile } = useCachedFile(typeof file === "string" ? file : undefined);
  const fileUrl = typeof file === "string" ? file : URL.createObjectURL(file);
  const finalUrl = cachedFile?.url || fileUrl;

  const name = typeof file === "string" ? file.split("/").pop()?.split(".")[0] || "file" : file.name.split(".").shift();
  const ext =
    typeof file === "string"
      ? file.split(".").pop()?.toUpperCase() || "FILE"
      : file.name.split(".").pop()?.toUpperCase() || "FILE";
      
  return (
    <div
      title={ext}
      // onClick={(e) => {
      //   e.preventDefault();
      //   e.stopPropagation();
      //   finalUrl && onClick?.(finalUrl);
      // }}
    //   onContextMenu={(e) => handleRightClick(e, "other", file)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "relative",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          opacity: hovered ? 0.9 : 1,
          backgroundColor: isSelected ? "#3284ff" : "#a5a5a5",
          color: "#555",
          fontWeight: "bold",
          fontSize: 12,
          height: 70,
          width: 70,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          transition: "opacity 0.25s ease",
          borderRadius: "1rem",
        }}
      >
        <div className="text-truncate text-center" style={{ width: "100%" }}>
        {name}
        </div>
        <div className="text-truncate text-center" style={{ width: "100%" }}>
        {ext}
        </div>
      </div>

      {hovered && finalUrl && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <Button
            variant="light"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              const filename =
                typeof file === "string" ? file.split("/").pop() || "file" : file.name;
              downloadFile(finalUrl, filename);
            }}
            style={{
              pointerEvents: "auto",
              borderRadius: "50%",
              width: "36px",
              height: "36px",
              padding: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 0 6px rgba(0,0,0,0.3)",
            }}
            title="Скачать файл"
          >
            <Download size={18} />
          </Button>
        </div>
      )}
    </div>
  );
};
